import {connect} from "react-redux";
import {checkDiscount, changeDiscountCode, clearDiscountCode} from "../actions";
import {getDiscountCode, isDiscountValid, needDiscountInitialCheck, getFilledEmail, getSelectedDoctypeId, getSelectedLevelId, getSelectedUrgencyId} from "../reducers";
import DiscountCode from "../component/DiscountCode";

const mapStateToProps = (state) => {
    return {
        discountCode: getDiscountCode(state),
        needDiscountInitialCheck: needDiscountInitialCheck(state),
        isValid: isDiscountValid(state),
        filledEmail: getFilledEmail(state),
        selectedDoctypeId: getSelectedDoctypeId(state),
        selectedLevelId: getSelectedLevelId(state),
        selectedUrgencyId: getSelectedUrgencyId(state),
    }
}

let lastTimer

const mergeProps = (stateProps, dispatchProps, ownProps) => {

    const {dispatch} = dispatchProps

    if (stateProps.needDiscountInitialCheck) {
        dispatch(checkDiscount(
            stateProps.filledEmail,
            stateProps.discountCode,
            1,
            stateProps.selectedDoctypeId,
            stateProps.selectedLevelId,
            stateProps.selectedUrgencyId
        ))
    }

    return Object.assign({}, ownProps, stateProps, {
        onChange: event => {
            const value = event.target.value

            dispatch(changeDiscountCode(event.target.value))

            if (value.length < 3) {
                return
            }

            if (lastTimer) {
                clearTimeout(lastTimer)
            }

            lastTimer = setTimeout(() => {
                dispatch(checkDiscount(
                    stateProps.filledEmail,
                    value,
                    1,
                    stateProps.selectedDoctypeId,
                    stateProps.selectedLevelId,
                    stateProps.selectedUrgencyId
                ))
            }, 500)
        },
        afterHide: () => {
            dispatch(clearDiscountCode())
        }
    });
}

export default connect(mapStateToProps, null, mergeProps)(DiscountCode);